var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flatfinder-filter-type-boolean"},[_c('div',{staticClass:"flatfinder-filter-type-boolean__header"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('FontAwesomeIcon',{staticClass:"ml-1",attrs:{"icon":_vm.$attrs.icon}})],1),_vm._t("remove")],2),_c('div',[_c('ChoiceComponent',{attrs:{"value":_vm.value,"values":[
        { label: _vm.$t('yes'), value: true },
        { label: _vm.$t('no'), value: false },
      ]},on:{"input":$ev => _vm.$emit('input', $ev)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }